// extracted by mini-css-extract-plugin
export default {"logoContainer":"shape-box_logoContainer__yBMUR","logoWrapper":"shape-box_logoWrapper__dsTUY","logo":"shape-box_logo__1J9h9"};